import type { TFunction } from 'i18next';

import yup from '../../../shared/validation';

export function getNewBugReportValidation(t: TFunction) {
  return yup.object({
    title: yup
      .string()
      .max(256, t('formikValidation.maxLength').replace('{0}', '256'))
      .required(t('formikValidation.nameRequired')),
    type: yup.object().required(t('formikValidation.typeRequired')),
    message: yup.string().required(t('formikValidation.nameRequired')),
  });
}
